module.exports = __webpack_public_path__ + "assets/google_playstore_logo.7f67808c.svg";